/**
 * Returns browser default font size
 */
export const getBrowserFontSize = (): number => {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
};

export const oneRem = getBrowserFontSize();
